(function () {
  function autoplayVideoSlide(slideEl) {
    const deferredMedia = slideEl.querySelector('deferred-media');
    if (!deferredMedia) return;

    if (!deferredMedia.getAttribute('loaded')) {
      const playButton = deferredMedia.querySelector('.deferred-media__poster-button');
      if (playButton) playButton.click();
    }

    setTimeout(() => {
      const video = deferredMedia.querySelector('video');
      if (video) {
        video.muted = true;
        video.controls = false;
        video.removeAttribute('controls');
        video.play().catch(() => {});

        // Après 2 secondes, réactive les contrôles au tap
        setTimeout(() => {
          video.controls = true;
        }, 2000);
      }
    }, 400);
  }

  function pauseVideoSlide(slideEl) {
    const video = slideEl.querySelector('video');
    if (video) video.pause();
  }

  function initGallery() {
    const sliderEl = document.querySelector('.product__media-list');
    if (!sliderEl) return;

    const slides = sliderEl.querySelectorAll('.product__media-item');
    if (!slides.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
          const slide = entry.target;
          slides.forEach(s => { if (s !== slide) pauseVideoSlide(s); });
          if (slide.classList.contains('product__media-item--full')) {
            autoplayVideoSlide(slide);
          }
        }
      });
    }, {
      root: sliderEl,
      threshold: 0.6
    });

    slides.forEach(slide => observer.observe(slide));

    const mutationObserver = new MutationObserver(() => {
      const activeSlide = sliderEl.querySelector('.product__media-item.is-active');
      if (activeSlide && activeSlide.classList.contains('product__media-item--full')) {
        slides.forEach(s => { if (s !== activeSlide) pauseVideoSlide(s); });
        autoplayVideoSlide(activeSlide);
      }
    });

    mutationObserver.observe(sliderEl, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGallery);
  } else {
    initGallery();
  }
})();